import React from 'react'
import { useTranslation } from 'react-i18next'

import { ContentStateProperty, FieldProps } from '../../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'

export interface LegalConstructionYearProps extends Omit<FieldProps<ConstructionScreenValidationResult>, 'onChange'> {
  validators: ConstructionScreenValidationResult
  onEnergyCertificateChange: (field: ContentStateProperty, value: string | boolean | undefined) => void
}

const LegalConstructionYearField: React.FC<LegalConstructionYearProps> = ({
  insertionData,
  validators,
  onEnergyCertificateChange,
  wrapperClassName,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='legal-construction-year'
        propertyName='legalConstructionYear'
        className='desk-margin-right-m'
        maxLength={999}
        label={<span>{t('wizard.screen.construction.legalConstructionYear', 'Legal Construction Year')}</span>}
        placeholder={t('wizard.screen.construction.constructionYearPlaceholder', 'eg. 1998')}
        value={insertionData.legalConstructionYear}
        errors={validators.legalConstructionYear ?? []}
        doOnFieldChange={(field, value) => onEnergyCertificateChange(field, value)}
      />
    </div>
  )
}

export default LegalConstructionYearField
